import {
  Actor,
  Animation,
  CollisionType,
  Keys,
  SpriteSheet,
  vec,
  Vector,
} from "excalibur";
import { Resources } from "../../Resources";
import { Config } from "../../config";
import Dialog from "../../ui/dialog";
import QuestionDialog from "../../ui/questionDialog";
import getNPCContent from "../../content/npcContent";
import { playerState } from "../../state/stateManager";
import { goToScene } from "../../main";

export default class Katie extends Actor {
  constructor(pos) {
    super({
      x: pos.x,
      y: pos.y,
      width: 32,
      height: 32,
      radius: 20,
      collisionType: CollisionType.Fixed,
      name: "katie",
    });
    this.autoMovements = [
      { type: "move", direction: "left", amount: 20 },
      { type: "move", direction: "right", amount: 20 },
    ];
    this.started = false;
    this.interacting = false;
    this.interactionTime = null;
    this.content = playerState.getContent();
  }

  onInitialize() {
    const playerSpriteSheet = SpriteSheet.fromImageSource({
      image: Resources.KatieSprites,
      grid: {
        spriteWidth: 32,
        spriteHeight: 32,
        rows: 5,
        columns: 8,
      },
    });

    const leftIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downIdle = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const downWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 0),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 0),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const upWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 1),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 1),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const leftWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 2),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 2),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    const rightWalk = new Animation({
      frames: [
        {
          graphic: playerSpriteSheet.getSprite(0, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(1, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(2, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(3, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(4, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(5, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(6, 3),
          duration: Config.PlayerFrameSpeed,
        },
        {
          graphic: playerSpriteSheet.getSprite(7, 3),
          duration: Config.PlayerFrameSpeed,
        },
      ],
    });
    this.graphics.add("leftIdle", leftIdle);
    this.graphics.add("rightIdle", rightIdle);
    this.graphics.add("upIdle", upIdle);
    this.graphics.add("downIdle", downIdle);
    this.graphics.add("leftWalk", leftWalk);
    this.graphics.add("rightWalk", rightWalk);
    this.graphics.add("upWalk", upWalk);
    this.graphics.add("downWalk", downWalk);
    this.graphics.use("downIdle");
    const shadowSprite = playerSpriteSheet.getSprite(0, 4);
    const shadow = new Actor({ pos: new Vector(0, 0), z: 2 });
    shadow.graphics.add("shadow", shadowSprite);
    shadow.graphics.use("shadow");
    this.addChild(shadow);
  }
  moveFunction(direction, amount) {
    console.log("cutscene: inside katie move");
    switch (direction) {
      case "left":
        this.graphics.use("leftWalk");
        this.vel = vec(-Config.GrandpaSpeed, 0);

        this.lastDir = "left";
        break;
      case "right":
        this.graphics.use("rightWalk");
        this.vel = vec(Config.GrandpaSpeed, 0);

        this.lastDir = "right";
        break;
      case "up":
        this.graphics.use("upWalk");
        this.vel = vec(0, -Config.GrandpaSpeed);

        this.lastDir = "up";
        break;
      case "down":
        this.graphics.use("downWalk");
        this.vel = vec(0, Config.GrandpaSpeed);

        this.lastDir = "down";
        break;
      default:
        break;
    }
  }
  startAuto() {
    console.log("inside startAuto");
    this.actions.repeatForever((ctx) => {
      this.started = true;
      ctx
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(28 * 16, 14 * 16, 30)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })

        .delay(1000)
        .callMethod(() => {
          this.graphics.use("upWalk");
        })
        .moveTo(28 * 16, 6 * 16, 30)
        .callMethod(() => {
          this.graphics.use("upIdle");
        })
        .delay(500)
        .callMethod(() => {
          this.graphics.use("rightWalk");
        })
        .moveTo(33 * 16, 6 * 16, 30)
        .callMethod(() => {
          this.graphics.use("rightIdle");
        })
        .delay(500)

        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(28 * 16, 6 * 16, 30)
        .callMethod(() => {
          this.graphics.use("leftIdle");
        })
        .delay(500)

        .callMethod(() => {
          this.graphics.use("downWalk");
        })
        .moveTo(28 * 16, 14 * 16, 30)
        .callMethod(() => {
          this.graphics.use("downIdle");
        })
        .delay(500)

        .callMethod(() => {
          this.graphics.use("leftWalk");
        })
        .moveTo(23 * 16, 14 * 16, 30)
        .callMethod(() => {
          this.graphics.use("leftIdle");
        })
        .delay(500);
    });
  }

  startInteraction(lastDir, player) {
    this.player = player;
    let now = new Date().getTime();
    if (this.interactionTime == null || now - this.interactionTime > 5000) {
      this.interacting = true;
      this.actions.clearActions();
      player.cutScene = true;
      console.log("inside startInteraction, ", lastDir);
      switch (lastDir) {
        case "left":
          this.graphics.use("rightIdle");
          break;
        case "right":
          this.graphics.use("leftIdle");
          break;
        case "up":
          this.graphics.use("downIdle");
          break;
        case "down":
          this.graphics.use("upIdle");
          break;
        default:
          break;
      }

      this.displayProperQuestion();
    } else {
      return;
    }
  }
  showDialog() {
    console.log("showing dialog: question is: ", this.activeQuestion);
    this.greetingDialog = new QuestionDialog(
      [this.activeQuestion.question],
      this.activeQuestion.replies,
      (reply, replyIndex) => {
        console.log("dialog ended");
        if (this.activeQuestion.replies.length !== 0) {
          this.setRepliesToState(this.activeQuestion.relationship[replyIndex]);
        } else {
          this.setRepliesToState({ shouldShow: null });
        }
      },
      "katie",
      "top"
    );
  }
  displayProperQuestion() {
    this.questions = getNPCContent();
    this.content = playerState.getContent();
    if (!this.content.katie.met) {
      console.log("havent met, showing first question");
      this.activeQuestion = this.questions.katie.questions.firstQuestion;
      this.content.brandAwareness = this.content.brandAwareness + 1;
      this.showDialog();
    } else {
      console.log(
        "have met, showing random,relationship is: ",
        this.content.katie.relationship
      );
      //random question based on relationship
      if (this.content.katie.relationship < 0) {
        let qu =
          this.questions.katie.randomQuestions.reallyLow[
            Math.floor(
              Math.random() *
                this.questions.katie.randomQuestions.reallyLow.length
            )
          ];
        this.activeQuestion = qu;
      } else if (
        this.content.katie.relationship < 10 &&
        this.content.katie.relationship >= 0
      ) {
        //low level question
        console.log("have met, relationship low");
        let qu =
          this.questions.katie.randomQuestions.lowLevel[
            Math.floor(
              Math.random() *
                this.questions.katie.randomQuestions.lowLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (10 <= this.content.katie.relationship <= 20) {
        //mid level question
        let qu =
          this.questions.katie.randomQuestions.midLevel[
            Math.floor(
              Math.random() *
                this.questions.katie.randomQuestions.midLevel.length
            )
          ];
        this.activeQuestion = qu;
      } else if (this.content.katie.relationship > 20) {
        //high level question
        let qu =
          this.questions.katie.randomQuestions.highLevel[
            Math.floor(
              Math.random() *
                this.questions.katie.randomQuestions.highLevel.length
            )
          ];
        this.activeQuestion = qu;
      }
      this.showDialog();
    }
  }
  setRepliesToState(relationshipImpact) {
    console.log(
      "inside setRepliesToState: relationshipimpact is: ",
      relationshipImpact
    );

    let content = playerState.getContent();
    if (relationshipImpact.relationshipBump) {
      content.katie.relationship =
        parseInt(content.katie.relationship) +
        parseInt(relationshipImpact.relationshipBump);
    }

    content.katie.met = true;
    this.content = content;
    if (relationshipImpact.shouldShow) {
      //should show followup dialog
      if (relationshipImpact.shouldShow == "sellHoney") {
        this.interacting = false;
        this.player.cutScene = false;
        goToScene("mccartysCommerce");
      } else {
        console.log(
          "shouldShow is: ",
          this.questions.katie.questions[relationshipImpact.shouldShow]
        );
        this.activeQuestion =
          this.questions.katie.questions[relationshipImpact.shouldShow];
        this.showDialog();
      }
    } else {
      this.player.cutScene = false;
      this.interacting = false;
      this.interactionTime = new Date().getTime();
      this.startAuto();
    }
  }
  onPostUpdate(engine) {
    if (!this.started && !this.cutScene) {
      this.startAuto();
    }
    if (this.interacting) {
      if (engine.input.keyboard.wasPressed(Keys.Enter)) {
        this.greetingDialog.enterPress();
      }
      if (engine.input.keyboard.wasPressed(Keys.Up)) {
        this.greetingDialog.iterateReply(true);
      }
      if (engine.input.keyboard.wasPressed(Keys.Down)) {
        this.greetingDialog.iterateReply(false);
      }
      if (engine.input.keyboard.wasPressed(Keys.X)) {
        this.interacting = false;
        this.player.cutScene = false;
        this.greetingDialog.destroy();
      }
    }
  }
}
